import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import axios from 'axios';
import { API_BASE } from '../config';

export default function Viewer() {
  const { jobId }  = useParams();
  const { user }   = useAuth();
  const [assets, setAssets]   = useState(null);
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const token = user ? await user.getIdToken() : 'stub';
        const headers = { 'Authorization': `Bearer ${token}`, 'x-api-key': 'test-key-123' };
        const { data } = await axios.get(`${API_BASE}/jobs/${jobId}/viewer-assets`, { headers });
        setAssets({ ...data, token });
        setLoading(false);
      } catch(e) {
        setError(e.response?.data?.detail || e.message);
        setLoading(false);
      }
    };
    load();
  }, [jobId, user]);

  if (loading) return (
    <div style={{height:'calc(100vh - 52px)',display:'flex',alignItems:'center',justifyContent:'center',
      fontFamily:'IBM Plex Mono,monospace',fontSize:12,color:'var(--muted)'}}>
      Loading viewer...
    </div>
  );

  if (error) return (
    <div style={{height:'calc(100vh - 52px)',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:16}}>
      <div style={{fontFamily:'IBM Plex Mono,monospace',fontSize:12,color:'var(--rust)'}}>
        Viewer unavailable: {error}
      </div>
      <Link to={`/jobs/${jobId}`} style={{color:'var(--muted)',fontSize:12,fontFamily:'IBM Plex Mono,monospace'}}>
        Back to job
      </Link>
    </div>
  );

  const params = new URLSearchParams();
  if (assets.cloud_url)        params.set('cloud', assets.cloud_url);
  if (assets.mesh_url)         params.set('mesh',  assets.mesh_url);
  if (assets.splat_url)        params.set('splat', assets.splat_url);
  if (assets.measurements_url) params.set('meas',  assets.measurements_url);
  params.set('job', jobId);

  const viewerSrc = `/viewer.html?${params.toString()}`;

  return (
    <div style={{height:'calc(100vh - 52px)',display:'flex',flexDirection:'column'}}>
      <div style={{
        height:36, background:'var(--surface)', borderBottom:'1px solid var(--border)',
        display:'flex', alignItems:'center', padding:'0 16px', gap:12, flexShrink:0,
      }}>
        <Link to={`/jobs/${jobId}`} style={{
          fontFamily:'IBM Plex Mono,monospace', fontSize:11,
          color:'var(--muted)', textDecoration:'none',
        }}>← Job {jobId.slice(0,8)}</Link>
        <div style={{
          fontFamily:'IBM Plex Mono,monospace', fontSize:10,
          color:'rgba(200,240,74,0.7)', letterSpacing:2, textTransform:'uppercase',
        }}>3D Viewer</div>
        <div style={{marginLeft:'auto',display:'flex',gap:8}}>
          {assets.cloud_url && <span style={{fontFamily:'IBM Plex Mono,monospace',fontSize:9,color:'var(--muted)'}}>⬡ Cloud</span>}
          {assets.mesh_url  && <span style={{fontFamily:'IBM Plex Mono,monospace',fontSize:9,color:'var(--muted)'}}>▣ Mesh</span>}
          {assets.splat_url && <span style={{fontFamily:'IBM Plex Mono,monospace',fontSize:9,color:'var(--muted)'}}>✦ Splat</span>}
        </div>
      </div>
      <iframe
        src={viewerSrc}
        style={{flex:1, border:'none', width:'100%'}}
        title="civil3d 3D Viewer"
      />
    </div>
  );
}
